import { signal } from '@angular/core';

import { Seite } from './Seite';
import { nextMonotonicNumber } from './monotonic-number';

export class Beleg {
  private readonly _belegSeiten = signal<Seite[]>([]);

  public readonly belegNumber: number;

  private _belegType!: BelegType;
  private _seitenCounter = 0;

  constructor(belegNumber: number) {
    this.belegNumber = belegNumber;
    this.belegType = BelegType.NOT_SET;
  }

  public get belegType(): BelegType {
    return this._belegType;
  }

  public set belegType(belegType: BelegType) {
    this._belegType = belegType;
  }

  public get seiten(): Seite[] {
    return this._belegSeiten();
  }

  public addSeite(seite: Seite, seitenNumber?: number): void {
    seite.seitenNumber = this.nextSeitenNumber(seitenNumber);
    this._belegSeiten.set([...this._belegSeiten(), seite]);
  }

  public clearBelegType(): void {
    this._belegType = BelegType.NOT_SET;
  }

  public getBelegSize(): Promise<number> {
    return this._belegSeiten().reduce(
      async (nextValue, currentValue) => (await nextValue) + (await currentValue.getSize()),
      Promise.resolve(0),
    );
  }

  public removeSeite(seite: Seite): void {
    this._belegSeiten.set(this._belegSeiten().filter((_seite) => _seite !== seite));
  }

  private nextSeitenNumber(seitenNumber?: number): number {
    const { assignedNumber, nextCounter } = nextMonotonicNumber(seitenNumber, this._seitenCounter);
    this._seitenCounter = nextCounter;
    return assignedNumber;
  }
}

export enum BelegType {
  NOT_SET,
  UNFALL_BELEG,
}
